export const NUMERIC_CONFIG = {
  decimal: {
    display: ',',
    internal: '.',
  },

  thousandSeparator: ' ',

  limits: {
    maxIntegerDigits: 15,
  },

  precision: {
    default: 2,
    extra: 1,
  },
} as const;
